/** Where the learning path catalog lives, and each path's learner page. */
export const learningPathCatalogPath = '/catalog/learning-path-catalog'
export const learnerLearningPathRoute = `${learningPathCatalogPath}/:publicId`

/**
 * A course's learner page opened from a learning path, for a course the path still gives after the
 * learner's organization lost the right to deliver it, so the course catalog's page no longer opens.
 */
export const learnerPathCourseRoute = `${learnerLearningPathRoute}/courses/:courseId`

/** A learning path's learner page. */
export function learnerLearningPathPath(id: string): string {
  return `${learningPathCatalogPath}/${encodeURIComponent(id)}`
}

/** A course's learner page opened from a learning path. */
export function learnerPathCoursePath(pathId: string, courseId: string): string {
  return `${learnerLearningPathPath(pathId)}/courses/${encodeURIComponent(courseId)}`
}

/**
 * The API's learner path endpoints. They are Entitlements', which knows the paths the caller holds
 * and reads the rest from Catalog (Aaron Mulder, 2026-10-21).
 */
export const myLearningPathsApi = '/entitlements/v1/me/learning-paths'

export function learnerLearningPathApi(id: string): string {
  return `${myLearningPathsApi}/${encodeURIComponent(id)}`
}

export function learnerPathCourseApi(pathId: string, courseId: string): string {
  return `${learnerLearningPathApi(pathId)}/courses/${encodeURIComponent(courseId)}`
}

/**
 * The slots the path pages offer other areas: `progress`, panels in a path's card on its learner
 * page, such as the step rail and "% complete" Learner History shows (LH-12).
 */
export const learningPathCatalogSlots = {
  progress: 'catalog.learner-learning-path.progress',
} as const
